import React from "react";
import { ListGroup } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Target } from "../core/models/Keyword";


interface SearchElementTileProps {
    target: Target,
}

const SearchElementTile: React.FC<SearchElementTileProps> = ({ target }) => {
    const navigator = useNavigate();

    function navigateToRoute() {
        navigator(`/${target.model.toLowerCase()}/${target.id}`);
    }
    
    return <ListGroup.Item
        as="li"
        className="d-flex justify-content-between align-items-start"
        onClick={navigateToRoute}
        action
    >
        <div className="ms-2 me-auto">
            <div className="fw-bold">{target.title}</div>
            <p>{target.description}</p>
        </div>
    </ListGroup.Item>;
}

export default SearchElementTile;